import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { servicesReducer } from "./reducer";
import {
  verifyIfscAction,
  getBankAccountInfoAction,
  getGstInfoAction,
  verifyPanAction,
  panAadharLinkStatusAction,
  verifyTanAction,
  verifyShippingAddressPanAction,
  authorizedVerifyPanAction,
} from "./actions";
import { ServicesTypes } from "./serviceTypes";

export const servicesSlice = createSlice({
  name: "services",
  initialState,
  reducers: servicesReducer,
  extraReducers: {
    [getGstInfoAction.pending.toString()]: (state: ServicesTypes) => ({
      ...state,
      fetching: true,
    }),
    [getGstInfoAction.fulfilled.toString()]: (
      state: ServicesTypes,
      { payload }
    ) => {
      const { success, data, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          gstDetails: null,
          success: 0,
        };
      }

      return {
        ...state,
        fetching: false,
        gstDetails: data,
        error: null,
        success,
      };
    },
    [getGstInfoAction.rejected.toString()]: (
      state: ServicesTypes,
      { error }
    ) => ({
      ...state,
      error: error.message,
      fetching: false,
    }),
    [verifyIfscAction.pending.toString()]: (state: ServicesTypes) => ({
      ...state,
      fetching: true,
    }),
    [verifyIfscAction.fulfilled.toString()]: (
      state: ServicesTypes,
      { payload }
    ) => {
      const { success, data, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          ifscDetails: null,
        };
      }

      return {
        ...state,
        fetching: false,
        ifscDetails: data,
        error: null,
      };
    },
    [verifyIfscAction.rejected.toString()]: (
      state: ServicesTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error.message,
    }),
    [getBankAccountInfoAction.pending.toString()]: (state: ServicesTypes) => ({
      ...state,
      fetching: true,
    }),
    [getBankAccountInfoAction.fulfilled.toString()]: (
      state: ServicesTypes,
      { payload }
    ) => {
      const { success, result, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        error: null,
        bankAccountDetails: {
          account_exists: result?.data?.account_exists ? "Yes" : "No",
          amount_deposited: "0",
          message:
           result?.data?.account_exists ?
            (result?.data?.message === "Given account is an NRE account" ||
             result?.data?.message === "Account is blocked")
              ? result?.data?.message
              : result?.data?.account_exists&& !result?.data?.message?"Bank Details is Verified"
              : result?.data?.account_exists && 
                "Bank Account details verified successfully.":result?.data?.message,
          name_at_bank: result?.data?.name_at_bank,
          
        },
      };
    },
    [getBankAccountInfoAction.rejected.toString()]: (
      state: ServicesTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error.message,
    }),
    [panAadharLinkStatusAction.pending.toString()]: (state: ServicesTypes) => ({
      ...state,
      fetching: true,
    }),
    [panAadharLinkStatusAction.fulfilled.toString()]: (
      state: ServicesTypes,
      { payload }
    ) => {
      const { success, message, data } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        panAadharLinkStatus: data,
      };
    },
    [panAadharLinkStatusAction.rejected.toString()]: (
      state: ServicesTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error.message,
    }),
    [verifyPanAction.pending.toString()]: (state: ServicesTypes) => ({
      ...state,
      fetching: true,
    }),
    [verifyPanAction.fulfilled.toString()]: (
      state: ServicesTypes,
      { payload }
    ) => {
      const { success, data, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        panVerifyDetails: data,
      };
    },
    [verifyPanAction.rejected.toString()]: (
      state: ServicesTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error.message,
    }),
    [authorizedVerifyPanAction.pending.toString()]: (state: ServicesTypes) => ({
      ...state,
      fetching: true,
    }),
    [authorizedVerifyPanAction.fulfilled.toString()]: (
      state: ServicesTypes,
      { payload }
    ) => {
      const { success, data, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        authorizedPanVerifyDetails: data,
      };
    },
    [authorizedVerifyPanAction.rejected.toString()]: (
      state: ServicesTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error.message,
    }),
    [verifyShippingAddressPanAction.pending.toString()]: (
      state: ServicesTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [verifyShippingAddressPanAction.fulfilled.toString()]: (
      state: ServicesTypes,
      { payload }
    ) => {
      const { success, data, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        shippingAddressPanVerifyDetails: data,
      };
    },
    [verifyShippingAddressPanAction.rejected.toString()]: (
      state: ServicesTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error.message,
    }),
    [verifyTanAction.pending.toString()]: (state: ServicesTypes) => ({
      ...state,
      fetching: true,
    }),
    [verifyTanAction.fulfilled.toString()]: (
      state: ServicesTypes,
      { payload }
    ) => {
      const { success, data, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        tanVerifyDetails: data,
      };
    },
    [verifyTanAction.rejected.toString()]: (
      state: ServicesTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
    }),
  },
});

export const {
  resetError: resetServicesError,
  resetSuccess: resetServicesSucces,
  resetIfscData,
  resetBankAccountDetails,
  resetGstDetails,
  resetPanVerifyData,
  resetTanVerifyData,
  resetPanAadharLinkStatus,
  resetServicesFetching,
  resetShippingAddressPanVerifyDetails,
  resetAuthorizedPanVerifyData,
} = servicesSlice.actions;
